import { zodPreferredDuration, zodFileUpload } from "@lib/validation/zodObjects";
import { z } from 'zod';

export const personalInfoSchema = z.object({
    Title: z.string().min(1, 'required').transform(Number),
    Firstname: z.string().min(1, 'required'), 
    FamilyName: z.string().min(1, 'required'),
    DateOfBirth: z.string().min(1, 'required'),
    PrimaryEmail: z.string().min(1, 'required'),
    Phone: z.string().min(1, 'required'),
    AdditionalEmail: z.string().optional()
});

export const availabilitySchema = z.object({
    Availability: z.string().optional(),             
    inhouse: z.string().min(1, "Please select a value").transform(Boolean)
}).refine((schema) => {
    const shortTerm = document.getElementById('ShortTerm') as HTMLInputElement;
    const longTerm = document.getElementById('LongTerm') as HTMLInputElement;
    if (shortTerm.checked || longTerm.checked) {
        return true;
    } 

    return false;
},
{ path: ["LongTerm"], message: "select at least one value" })

export const cvUploadSchema = z.object({
    CvUpload: zodFileUpload
});

export const writingCentreSchema = z.object({
    coopWritingCentre: z.boolean().optional(),
    IsAccepted: z.string()
        .refine((arg) => {
            if (arg == "true") {
                return true;
            }
            return false
        }, 
        { message: "Please accepted terms and conditions" })
});

export type PersonalInfoValidationSchema = z.infer<typeof personalInfoSchema>;
export type AvailabilityStepValidationSchema = z.infer<typeof availabilitySchema>;
export type UploadCvStepValidationSchema = z.infer<typeof cvUploadSchema>;
export type WritingCentreStepValidationSchema = z.infer<typeof writingCentreSchema>;
